import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { UserProvider, useUser } from "@/contexts/UserContext";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import BucketList from "@/pages/BucketList";
import CompleteItem from "@/pages/CompleteItem";
import Memories from "@/pages/Memories";
import Characters from "@/pages/Characters";
import CreateCharacter from "@/pages/CreateCharacter";
import Login from "@/pages/Login";
import PawSpinner from "@/components/PawSpinner";
import "@/App.css";

function AppContent() {
  const { userId, loading } = useUser();
  const location = useLocation();

  if (location.pathname === "/login") {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
      </Routes>
    );
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-cream flex items-center justify-center">
        <PawSpinner size="lg" />
      </div>
    );
  }

  if (!userId) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/bucketlist" element={<BucketList />} />
        <Route path="/complete/:id" element={<CompleteItem />} />
        <Route path="/memories" element={<Memories />} />
        <Route path="/characters" element={<Characters />} />
        <Route path="/characters/new" element={<CreateCharacter />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <UserProvider>
      <BrowserRouter>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              background: "#FFFFFF",
              border: "1px solid #F0E0E5",
              color: "#2C1A1D",
              fontFamily: '"DM Sans", sans-serif',
            },
          }}
        />
        <AppContent />
      </BrowserRouter>
    </UserProvider>
  );
}

export default App;
